export const MODULE = 'tradeNotification';
